<script setup lang="ts">
const props = defineProps<{ product: SingleProduct }>();

useSchemaOrgData(props.product);
</script>

<template>
  <main id="main-content">
    <UiProductsTemplatesPluss
      v-if="product?.template === 'pluss'"
      :product="product"
    />
    <UiProductsTemplatesStandard v-else :product="product">
      <template #hero>
        <UiProductsHeroGrunnskole
          v-if="product?.template === 'grunnskole'"
          :product="product"
        />
        <UiProductsHeroVgs
          v-else-if="product?.template === 'standard'"
          :product="product"
        />
      </template>
    </UiProductsTemplatesStandard>
    <section v-if="product.pendelCta" class="w-full bg-white pb-14">
      <UiProductsPendelCta :product="product" />
    </section>
  </main>
</template>
